/** transform locales like "en_us" or "en-US" to "en" which can be used by dayjs */
export function getLanguageFromLocale(locale: string): string {
    if (typeof locale !== "string" || locale.length < 1) {
        return "";
    }
    return locale.split(/[-_]/, 1)[0];
}
